import styled, { css } from 'styled-components'
import {
  customizeVerticalScrollbarThumbMixin,
  disableSomeContentStyles
} from 'styles/mixins'
import { SMALL_DESKTOP_SIZE_BREAKPOINT } from 'consts'

import { COLORS } from 'consts/colors'

export const Container = styled.section<{
  $disabled?: boolean
  $isLoading?: boolean
}>`
  width: 100%;
  height: 100%;
  padding-top: 18px;
  display: flex;
  flex-direction: column;
  position: relative;

  ${({ $disabled }) =>
    $disabled &&
    css`
      ${disableSomeContentStyles(0.5)}
    `}
`

export const Controls = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
`

export const FilterButton = styled.div<{ $isOpen?: boolean }>`
  width: max-content;

  .filter-btn {
    width: auto;
    height: 36px;
    padding: 6px 12px;
    border: none;
    > span {
      font-size: 14px;
    }

    &::after {
      content: '';
      display: inline-block;
      width: 0;
      height: 0;
      margin-left: 6px;
      border-left: 4px solid transparent;
      border-right: 4px solid transparent;
      border-top: 4px solid ${COLORS.secondarySemiDark};
      transition: transform 0.2s ease;
      ${({ $isOpen }) => $isOpen && 'transform: rotate(180deg);'}
    }
  }
`

export const ResetButton = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: ${COLORS.primaryDark};
  cursor: pointer;
`

export const ItemsContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  overflow: hidden;
  align-content: flex-start;
  justify-content: flex-start;
  overflow-y: auto;
  padding: 16px 0;
  ${customizeVerticalScrollbarThumbMixin()}

  &::after {
    content: '';
    max-width: 164px;
    width: 100%;
  }

  @media (max-width: ${SMALL_DESKTOP_SIZE_BREAKPOINT}px) {
    justify-content: flex-start;

    &::after {
      max-width: 48%;
    }
  }
`
